import htmx from 'htmx.org'
import 'iconify-icon'

window.htmx = htmx
